<template>
    <div>        
        <q-inner-loading
            :showing="!loadingFinish"
            :label="loadingMessage"
            label-class="text-teal"
            label-style="font-size: 1.1em"
        />

        <div class="map-overlay">
            <div id="map"></div>
            
            <div class="map-header-banner">

            </div>
            
            <div class="toggle-btn" :style="isOpen ? 'right: 350px;' : 'right: 20px'" @click="toggleSidebar">
                <q-icon :name="isOpen ? 'chevron_right' : 'chevron_left'" size="24px" />
            </div>

            <div class="map-sidebar" :class="{ open: isOpen }" style="margin-left">
                <div class="map-sidebar-group">
                    <div class="section-header">
                        <q-icon name="map" class="q-mr-sm" />
                        Map Control
                    </div>
                    <div class="section-content">
                    <q-list>                        
                        <q-expansion-item
                            class="custom-expansion-item"
                            icon="layers"
                            label="Map Dataset"
                            header-class="text-primary text-weight-bold"
                            default-opened
                        >
                            <q-card flat class="q-pa-md">
                                <q-select
                                    dense
                                    outlined
                                    v-model="dataset"
                                    :options="datasetOptions"
                                    option-label="label"
                                    option-value="field"
                                    emit-value
                                    map-options
                                    label="Select Dataset"
                                    class="custom-select"
                                    color="primary"
                                />
                            </q-card>
                        </q-expansion-item>
                          <q-expansion-item
                            v-if="dataset === 'Purapura Whetu'"
                            class="custom-expansion-item"
                            icon="filter_list"
                            label="Client Status Filter"
                            header-class="text-secondary text-weight-bold"
                            default-opened
                        >
                            <q-card flat class="q-pa-md">
                                <q-toggle
                                    v-model="activeClientsOnly"
                                    label="Active Clients Only"
                                    color="secondary"
                                    class="text-weight-medium"
                                />
                                <div class="text-caption text-grey-7 q-mt-sm">
                                    Filter map data to show only active clients
                                </div>                            
                            </q-card>
                        </q-expansion-item>
                        <q-expansion-item
                            v-if="dataset === 'Purapura Whetu'"
                            class="custom-expansion-item"
                            icon="date_range"
                            label="Date Filters"
                            header-class="text-green-7 text-weight-bold"
                        >                            
                        <q-card flat class="q-pa-md">
                                <q-input
                                    dense
                                    outlined
                                    v-model="entryDateFrom"
                                    mask="####-##-##"
                                    :placeholder="dateFormat"
                                    clearable
                                    label="Entry Date From"
                                    class="custom-select"
                                    color="green-7"
                                    :rules="[(val) => (dayjs(val, dateFormat, true).isValid() || val == '') || 'Please enter a valid date']"
                                >
                                    <template v-slot:append>
                                        <q-icon name="event" class="cursor-pointer">
                                            <q-popup-proxy transition-show="scale" transition-hide="scale">
                                                <q-date v-model="entryDateFrom" :mask="dateFormat" />
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                                <q-input
                                    dense
                                    outlined
                                    v-model="entryDateTo"
                                    mask="####-##-##"
                                    :placeholder="dateFormat"
                                    clearable
                                    label="Entry Date To"
                                    class="custom-select"
                                    color="green-7"
                                    :rules="[(val) => (dayjs(val, dateFormat, true).isValid() || val == '') || 'Please enter a valid date']"
                                >
                                    <template v-slot:append>
                                        <q-icon name="event" class="cursor-pointer">
                                            <q-popup-proxy transition-show="scale" transition-hide="scale">
                                                <q-date v-model="entryDateTo" :mask="dateFormat" />
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                                <q-input
                                    dense
                                    outlined
                                    v-model="exitDateFrom"
                                    mask="####-##-##"
                                    :placeholder="dateFormat"
                                    clearable
                                    label="Exit Date From"
                                    class="custom-select"
                                    color="green-7"
                                    :rules="[(val) => (dayjs(val, dateFormat, true).isValid() || val == '') || 'Please enter a valid date']"
                                >
                                    <template v-slot:append>
                                        <q-icon name="event" class="cursor-pointer">
                                            <q-popup-proxy transition-show="scale" transition-hide="scale">
                                                <q-date v-model="exitDateFrom" :mask="dateFormat" />
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                                <q-input
                                    dense
                                    outlined
                                    v-model="exitDateTo"
                                    mask="####-##-##"
                                    :placeholder="dateFormat"
                                    clearable
                                    label="Exit Date To"
                                    class="custom-select"
                                    color="green-7"
                                    :rules="[(val) => (dayjs(val, dateFormat, true).isValid() || val == '') || 'Please enter a valid date']"
                                >
                                    <template v-slot:append>
                                        <q-icon name="event" class="cursor-pointer">
                                            <q-popup-proxy transition-show="scale" transition-hide="scale">
                                                <q-date v-model="exitDateTo" :mask="dateFormat" />
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                                <div class="text-caption text-grey-7 q-mt-sm">
                                    Filter clients based on their entry and exit dates
                                </div>
                            </q-card>
                        </q-expansion-item>
                            <q-expansion-item
                                v-if="dataset === 'Purapura Whetu'"
                                class="custom-expansion-item"
                                icon="groups"
                                label="Data Source"
                                header-class="text-orange-7 text-weight-bold"
                            >
                                <q-card flat class="q-pa-md">
                                    <q-select
                                        dense
                                        outlined
                                        v-model="databaseType"
                                        clearable
                                        :options="Object.keys(databaseTypeOptions)"
                                        label="Paua Database"
                                        class="custom-select"
                                        color="orange-7"
                                    />
                                    <q-select
                                        dense
                                        outlined
                                        v-model="serviceType"
                                        clearable
                                        :options="serviceTypeOptions"
                                        label="Service Types"
                                        class="custom-select"
                                        color="orange-7"
                                    />
                                </q-card>
                            </q-expansion-item>
                          <q-expansion-item
                            v-if="dataset === 'Purapura Whetu' || dataset === 'ASA'"
                            class="custom-expansion-item"
                            icon="people"
                            label="Demographic Filters"
                            header-class="text-purple-7 text-weight-bold"
                        >
                            <q-card flat class="q-pa-md">
                                <div v-if="loadingDemographicFilters" class="text-center q-pa-md">
                                    <q-spinner color="purple-7" size="24px" />
                                    <div class="text-caption text-grey-7 q-mt-sm">Loading filter options...</div>
                                </div>                                
                                <div v-else>
                                    <q-select
                                        dense
                                        outlined
                                        v-model="selectedGender"
                                        clearable
                                        :options="genderOptions"
                                        label="Gender"
                                        class="custom-select"
                                        color="purple-7"
                                    />
                                    <q-select
                                        dense
                                        outlined
                                        v-model="selectedAgeRange"
                                        clearable
                                        :options="ageRangeOptions"
                                        label="Age Range"
                                        class="custom-select"
                                        color="purple-7"
                                    />
                                    <q-select
                                        dense
                                        outlined
                                        v-model="selectedIwi"
                                        clearable
                                        :options="iwiOptions"
                                        label="Iwi"
                                        class="custom-select"
                                        color="purple-7"
                                    />
                                    <q-select
                                        dense
                                        outlined
                                        v-model="selectedEthnicity"
                                        clearable
                                        :options="ethnicityOptions"
                                        label="Ethnicity"
                                        class="custom-select"
                                        color="purple-7"
                                    />
                                </div>
                                <div class="text-caption text-grey-7 q-mt-sm">
                                    Filter clients based on demographic characteristics
                                </div>
                            </q-card>
                        </q-expansion-item>     
                        <q-expansion-item
                            v-if="dataset === 'Purapura Whetu'"
                            class="custom-expansion-item"
                            icon="interests"
                            label="Wellbeing Areas"
                            header-class="text-blue-7 text-weight-bold"
                        >
                            <q-card flat class="q-pa-md">
                                <q-select
                                    dense
                                    outlined
                                    v-model="selectedWellbeing"
                                    clearable
                                    :options="wellbeingOptions"
                                    label="Wellbeing Area"
                                    map-options
                                    emit-value
                                    option-value="id"
                                    option-label="title"
                                    class="custom-select"
                                    color="purple-7"
                                />
                            </q-card> 
                        </q-expansion-item>               
                        <q-expansion-item
                            v-if="dataset === 'ASA'"
                            class="custom-expansion-item"
                            icon="filter_list"
                            label="Other Filters"
                            header-class="text-pink-7 text-weight-bold"
                        >
                            <q-card flat class="q-pa-md">
                                <q-select
                                    dense
                                    outlined
                                    v-model="asaSelectedSchool"
                                    clearable
                                    :options="asaSchoolOptions"
                                    label="School"
                                    class="custom-select"
                                    color="pink-7"
                                />
                            </q-card>
                        </q-expansion-item>
                    </q-list>
                    </div>
                </div>
                <div class="map-sidebar-group">
                    <div class="section-header">
                        <q-icon name="layers" class="q-mr-sm" />
                        Map Overlay
                    </div>
                    <div class="section-content">
                        <div class="overlay-button-group">
                            <q-btn
                                :color="selectedOverlay === 'data-maori-descent' ? 'secondary' : 'grey-4'"
                                :text-color="selectedOverlay === 'data-maori-descent' ? 'white' : 'grey-8'"
                                class="text-weight-medium"
                                no-caps
                                unelevated
                                label="Māori Descent"
                                @click="changeLayers('data-maori-descent')"
                                :disable="!loadingFinish"
                                :loading="!loadingFinish && selectedOverlay === 'data-maori-descent'"
                            />
                            <q-btn
                                :color="selectedOverlay === 'data-social-deprivation' ? 'secondary' : 'grey-4'"
                                :text-color="selectedOverlay === 'data-social-deprivation' ? 'white' : 'grey-8'"
                                class="text-weight-medium"
                                no-caps
                                unelevated
                                label="Social Deprivation"
                                @click="changeLayers('data-social-deprivation')"
                                :disable="!loadingFinish"
                                :loading="!loadingFinish && selectedOverlay === 'data-social-deprivation'"
                            />
                            <q-btn
                                :color="selectedOverlay === 'data-ethnicity' ? 'secondary' : 'grey-4'"
                                :text-color="selectedOverlay === 'data-ethnicity' ? 'white' : 'grey-8'"
                                class="text-weight-medium"
                                no-caps
                                unelevated
                                label="Ethnicity Data"
                                @click="changeLayers('data-ethnicity')"
                                :disable="!loadingFinish"
                                :loading="!loadingFinish && selectedOverlay === 'data-ethnicity'"
                            />
                            <q-btn
                                :color="selectedOverlay === 'data-smoking' ? 'secondary' : 'grey-4'"
                                :text-color="selectedOverlay === 'data-smoking' ? 'white' : 'grey-8'"
                                class="text-weight-medium"
                                no-caps
                                unelevated
                                label="Smoking"
                                @click="changeLayers('data-smoking')"
                                :disable="!loadingFinish"
                                :loading="!loadingFinish && selectedOverlay === 'data-smoking'"
                            />
                        </div>
                    </div>
                </div>                
                <div class="map-sidebar-group">
                    <div class="section-header">
                        <q-icon name="person" class="q-mr-sm" />
                        <span v-if="dataset === 'Purapura Whetu' && activeClientsOnly">
                            Client Count
                        </span>
                        <span v-else>
                            Client Count
                        </span>
                    </div>
                    <div class="section-content">
                        <div class="q-pa-lg text-center text-h5">
                            <span v-if="loadingFinish" >{{ totalActiveClients }}</span>
                            <q-spinner v-else size="32px" color="secondary"></q-spinner>
                        </div>
                    </div>
                    <q-tooltip class="text-body2 bg-white text-black text-center">
                        <span v-if="dataset === 'Purapura Whetu' && activeClientsOnly">
                            Number of active clients represented on the map. Only clients with an address in Paua are counted.
                        </span>
                        <span v-else>
                            Number of clients represented on the map. Only clients with an address in Paua are counted.
                        </span>
                    </q-tooltip>
                </div>

                <div class="map-sidebar-group">
                    <div class="section-header">
                        <q-icon name="palette" class="q-mr-sm" />
                        Data Legend
                    </div>
                    <div class="section-content">
                        <!-- Client Address Legend -->
                        <div v-if="legendLayer === 'address'" class="legend-container">
                            <div class="legend-items">
                                <div class="legend-item" v-for="item in addressLegendData" :key="item.range">
                                    <div class="legend-color-box" :style="{ backgroundColor: item.color }"></div>
                                    <span class="legend-label text-body2 text-weight-medium">{{ item.range }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Ethnicity/Other Data Legend -->
                        <div v-else class="legend-container">
                            <div class="legend-header text-center">
                                <span class="text-h6 text-weight-medium">Legend for {{ legendLayer.replace('-', ' ') }}</span>
                            </div>
                            <q-separator class="q-ma-sm" />
                            <div class="legend-items">
                                <div class="legend-item" v-for="item in ethnicityLegendData" :key="item.range">
                                    <div class="legend-color-box" :style="{ backgroundColor: item.color }"></div>
                                    <span class="legend-label text-body2 text-weight-medium">{{ item.range }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <q-linear-progress 
            v-if="!loadingFinish"
            indeterminate 
            position="none"
            color="secondary"
            class="progress-bar-bottom force-absolute"
            size="20px" 
        />
    </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import mapSetup from '../../services/util/map/mapSetup';
import api from "../../services/api/api";
import mapLayers from '../../services/util/map/mapLayer';
import notify from "../../services/util/notify"
import token from "@/services/util/roleHandler";
import { hasFeature } from "@/services/util/featureHandler";
import dayjs from "../../services/util/dayjs";

export default {
    name: "ClientMapComponent",
    setup() {        const map = ref(null);
        const loadingFinish = ref(false);
        const firstLoad = ref(true);
        const totalActiveClients = ref(null);
        const loadingMessage = ref('Please wait...');

        // Debounce to prevent rapid-fire endpoint calls
        let updateTimeout = null;
        let isUpdating = false; // Flag to prevent concurrent updates
        const MIN_LOADING_TIME = 500; // Minimum time to show loading indicator (ms)

        const datasetOptions = ref([{
            label: 'All Purapura Whetu Clients',
            field: 'Purapura Whetu'
        }, {
            label: 'All Pae Ora Waitaha Clients',
            field: 'Pae Ora Waitaha'
        }]);
        const dataset = ref('Purapura Whetu');

        const serviceTypeOptions = ref([])
        const serviceType = ref(null);

        const databaseTypeOptions = ref([]);
        const databaseType = ref(null);

        const activeClientsOnly = ref(true);
        const userEmail = token.getEmail();

        const layers = ['data-clientAddress', 'data-smoking', 'data-maori-descent', 'data-social-deprivation', 'data-ethnicity'];
        const legendLayer = ref('address');

        const dateFormat = 'YYYY-MM-DD';
        const entryDateFrom = ref('');
        const entryDateTo = ref('');
        const exitDateFrom = ref('');
        const exitDateTo = ref('');

        const asaSchoolOptions = ref(null);
        const asaEthnicityOptions = ref(null);
        const asaSelectedSchool = ref(null);
        const asaSelectedEthnicity = ref(null);

        const genderOptions = ref([]);
        const ageRangeOptions = ref([]);
        const iwiOptions = ref([]);
        const ethnicityOptions = ref([]);
        const selectedGender = ref(null);
        const selectedAgeRange = ref(null);
        const selectedIwi = ref(null);
        const selectedEthnicity = ref(null);

        const loadingDemographicFilters = ref(false);

        const wellbeingOptions = ref(null);
        const selectedWellbeing = ref(null);
        
        const isOpen = ref(true)
        const selectedOverlay = ref(null);
        const addressLegendData = ref([
            { range: '30+%', color: '#2b0000' },
            { range: '25-29%', color: '#073763' },
            { range: '20-24%', color: '#134f5c' },
            { range: '15-19%', color: '#6aa84f' },
            { range: '10-14%', color: '#ffd966' },
            { range: '5-9%', color: '#f9cb9c' },
            { range: '0-4%', color: '#f4cccc' }
        ]);
        const ethnicityLegendData = ref([
            { range: '0 - 4%', color: '#e3c27b' },
            { range: '5 - 9%', color: '#d1c51d' },
            { range: '10 - 15%', color: '#b2eb15' },
            { range: '15 - 19%', color: '#55b519' },
            { range: '20 - 24%', color: '#42c9a1' },
            { range: '25 - 29%', color: '#139eba' },
            { range: '30 - 44%', color: '#0a63ab' },
            { range: '45 - 59%', color: '#5336e3' },
            { range: '60 - 74%', color: '#9536e3' },
            { range: '75 - 89%', color: '#a30bb8' },
            { range: '90+%', color: '#b5144f' }
        ])
        
        const toggleSidebar = () => {
            isOpen.value = !isOpen.value;
        }
        
        /**
         * Updates map layers based on a dataset and service type
         * @param firstLoad - Indicates if this is the first time loading any dataset
         */
        const updateMapLayers = async (firstLoad) => {
            let reload = false;
            if (!serviceType.value && (dataset.value === 'Purapura Whetu')) {
                reload = true;
            }            
            if (!(selectedEthnicity.value && asaSelectedSchool.value) && (dataset.value === 'ASA')) {
                reload = true;
            }
            if (!map.value) return;

            try {
                // Ensure layers are properly removed before adding new ones
                mapLayers.removeLayers(map.value);
                
                // Small delay to ensure cleanup is complete
                await new Promise(resolve => setTimeout(resolve, 50));                
                const activeFilter = dataset.value === 'Purapura Whetu' ? activeClientsOnly.value : undefined;                
                const result = await mapSetup.datasetConfig(
                    dataset.value, 
                    map.value, 
                    firstLoad, 
                    serviceType.value, 
                    selectedEthnicity.value, 
                    asaSelectedSchool.value, 
                    reload, 
                    databaseTypeOptions.value[databaseType.value], 
                    activeFilter,
                    entryDateFrom.value,
                    entryDateTo.value,
                    exitDateFrom.value,
                    exitDateTo.value,
                    selectedGender.value,
                    selectedAgeRange.value,
                    selectedIwi.value,
                    selectedWellbeing.value,
                );
                
                return result;
            } catch (error) {
                if (error.response && error.response.data) {
                    notify.error(`Failed to load ${dataset.value} dataset: ${error.response.data}`, 'top');
                } else {
                    notify.error(`Failed to load ${dataset.value} dataset. Please check your connection and try again.`, 'top');
                }
            }
        };        
        
        //Debounced version of updateMapLayers to prevent rapid-fire calls
        const debouncedUpdateMapLayers = (firstLoad) => {
            if (updateTimeout) {
                clearTimeout(updateTimeout);
            }
            
            if (!isUpdating) {
                loadingFinish.value = false;
            }
            
            updateTimeout = setTimeout(async () => { 
                // Prevent concurrent updates
                if (isUpdating) {
                    return;
                }
                
                isUpdating = true;
                // Ensure loading indicator is shown
                loadingFinish.value = false;
                loadingMessage.value = 'Loading map data...';
                
                try {
                    const startTime = Date.now();
                    
                    const mapResult = await updateMapLayers(firstLoad);
                    
                    loadingMessage.value = 'Updating client count...';
                    
                    // Only get actual client count if there was map data, otherwise set to 0
                    if (mapResult && mapResult.hasData === false) {
                        totalActiveClients.value = 0;
                    } else {
                        await getClientCount();
                    }
                    
                    // Ensure minimum loading time for better UX
                    const elapsedTime = Date.now() - startTime;
                    const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsedTime);
                    if (remainingTime > 0) {
                        loadingMessage.value = 'Finishing up...';
                        await new Promise(resolve => setTimeout(resolve, remainingTime));
                    }
                    
                } catch (error) {
                    // Update error occurred
                } finally {
                    loadingFinish.value = true;
                    loadingMessage.value = 'Please wait...';
                    isUpdating = false;
                }
            }, 300); // 300ms debounce delay
        };     


        const databaseFilters = async () => {
            const fetchData = () => Promise.all([
                api.client.getServicesList(),
                api.client.getDatabaseList()
            ])

            fetchData().then((values) => {
                serviceTypeOptions.value = values[0]['data']['services'];

                values[1].data.databases.forEach(source => {
                    const formatted = source
                        .toLowerCase()
                        .split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');
                    databaseTypeOptions.value[formatted] = source;
                });
            })
        }     

        // Fetch demographic filter options      
        const loadDemographicFilters = async () => {
            try {
                loadingDemographicFilters.value = true;
                
                genderOptions.value = [
                    'Male',
                    'Female', 
                    'Gender Diverse',
                    'Non-binary'
                ];

                // Load dataset-specific options
                await Promise.all([loadAgeRangeOptions(), loadIwiOptions(), loadEthnicityOptions()]);
            } catch (error) {
                console.error('Error loading demographic filters:', error);
                notify.error('Failed to load demographic filter options', 'top');
                
                // Fallback options
                genderOptions.value = ['Male', 'Female'];
                ageRangeOptions.value = ['0 - 11', '12 - 17', '18 - 24', '25 - 64', '65 +'];
                iwiOptions.value = [];
                ethnicityOptions.value = [];
            } finally {
                loadingDemographicFilters.value = false;
            }
        }
        
        // Load Iwi options based on the current dataset
        const loadIwiOptions = async () => {
            try {
                if (dataset.value === 'Purapura Whetu') {
                    const iwiResponse = await api.client.getIwiData();
                    if (iwiResponse && iwiResponse.data && iwiResponse.data.iwis) {
                        iwiOptions.value = iwiResponse.data.iwis;
                    } else {
                        iwiOptions.value = [];
                    }
                } else if (dataset.value === 'ASA') {
                    const iwiResponse = await api.asa.getASAIwiList();
                    if (iwiResponse && iwiResponse.data && iwiResponse.data.iwis) {
                        iwiOptions.value = iwiResponse.data.iwis;
                    } else {
                        iwiOptions.value = [];
                    }
                } else {
                    // Pae Ora or other datasets don't have Iwi data
                    iwiOptions.value = [];
                }
            } catch (error) {
                console.error('Error loading Iwi options:', error);
                notify.error(`Failed to load Iwi options for ${dataset.value}`, 'top');
                iwiOptions.value = [];
            }
        }

        // Load Ethnicity options based on the current dataset
        const loadEthnicityOptions = async () => {
            try {
                if (dataset.value === 'Purapura Whetu') {
                    const ethnicityResponse = await api.client.getEthnicityList();
                    if (ethnicityResponse && ethnicityResponse.data && ethnicityResponse.data.ethnicities) {
                        ethnicityOptions.value = ethnicityResponse.data.ethnicities;
                    } else {
                        ethnicityOptions.value = [];
                    }
                } else if (dataset.value === 'ASA') {
                    const ethnicityResponse = await api.asa.getASAEthnicityList();
                    if (ethnicityResponse && ethnicityResponse.data) {
                        ethnicityOptions.value = ethnicityResponse.data;
                    } else {
                        ethnicityOptions.value = [];
                    }
                } else {
                    // Pae Ora or other datasets don't have ethnicity data
                    ethnicityOptions.value = [];
                }
            } catch (error) {
                console.error('Error loading Ethnicity options:', error);
                notify.error(`Failed to load Ethnicity options for ${dataset.value}`, 'top');
                ethnicityOptions.value = [];
            }
        }
        
        // Load Age Range options based on the current dataset
        const loadAgeRangeOptions = async () => {
            try {
                if (dataset.value === 'Purapura Whetu') {
                    // Purapura Whetu uses standard age ranges
                    ageRangeOptions.value = [
                        '0 - 11',
                        '12 - 17', 
                        '18 - 24',
                        '25 - 64',
                        '65 +'
                    ];
                } else if (dataset.value === 'ASA') {
                    // ASA uses school-appropriate age ranges from backend
                    const ageRangeResponse = await api.asa.getASAAgeRangeList();
                    if (ageRangeResponse && ageRangeResponse.data && ageRangeResponse.data.ageRanges) {
                        ageRangeOptions.value = ageRangeResponse.data.ageRanges;                    } else {
                        // Fallback to simplified age ranges
                        ageRangeOptions.value = [
                            '5 - 12',
                            '13 - 18'
                        ];
                    }
                } else {
                    // Pae Ora or other datasets use standard ranges
                    ageRangeOptions.value = [
                        '0 - 11',
                        '12 - 17', 
                        '18 - 24',
                        '25 - 64',
                        '65 +'
                    ];
                }            } catch (error) {
                console.error('Error loading Age Range options:', error);
                notify.error(`Failed to load Age Range options for ${dataset.value}`, 'top');
                // Fallback options based on dataset
                if (dataset.value === 'ASA') {
                    ageRangeOptions.value = ['5 - 12', '13 - 18'];
                } else {
                    ageRangeOptions.value = ['0 - 11', '12 - 17', '18 - 24', '25 - 64', '65 +'];
                }
            }
        }
        
        // Load Wellbeing options for Purapura Whetu dataset
        const loadWellbeingOptions = async () => {
            try {
                let response = await api.wellbeing.wellbeingAreas();
                wellbeingOptions.value = response.data
            } catch (error) {
                console.error(error);
                notify.error('Failed to load wellbeing options', 'top');
                wellbeingOptions.value = [];
            } 
        };

        /**
         * Swaps what layers are visible based on the map
         * @param filterLayer - Indicates what layer should be toggled
         */
        const changeLayers = (filterLayer) => {
            const currentVisibility = map.value.getLayoutProperty(filterLayer, 'visibility');
            if (currentVisibility === 'visible') {
                selectedOverlay.value = null;
                for (const layer of layers) {
                    if (layer === 'data-clientAddress') {
                        map.value.setLayoutProperty(layer, 'visibility', 'visible');
                    } else {
                        map.value.setLayoutProperty(layer, 'visibility', 'none');
                    }
                }
            } else {
                selectedOverlay.value = filterLayer
                for (const layer of layers) {
                    if (layer === filterLayer) {
                        map.value.setLayoutProperty(layer, 'visibility', 'visible');
                    } else {
                        map.value.setLayoutProperty(layer, 'visibility', 'none');
                    }
                }
            }            
            const addressVisibility = map.value.getLayoutProperty('data-clientAddress', 'visibility');
            if (addressVisibility === 'visible') {
                legendLayer.value = 'address';
            } else {
                let filter = filterLayer.split('data-')[1].replace('-', ' ');
                legendLayer.value = filter;
            }
        };     
        
        
        const getClientCount = async () => {
            try {
                const activeFilter = dataset.value === 'Purapura Whetu' ? activeClientsOnly.value : true;                
                let countRequest = await api.map.getClientCount(
                    dataset.value, 
                    activeFilter, 
                    serviceType.value, 
                    databaseTypeOptions.value[databaseType.value],
                    entryDateFrom.value,
                    entryDateTo.value,
                    exitDateFrom.value,
                    exitDateTo.value,
                    selectedGender.value,
                    selectedAgeRange.value,
                    selectedIwi.value,
                    selectedEthnicity.value,
                    asaSelectedSchool.value,
                    selectedWellbeing.value
                );
                totalActiveClients.value = countRequest.data;
            } catch (error) {
                console.error('Error getting client count:', error);
                if (error.response) {
                    notify.error(`Failed to get client count: ${error.response.data || 'Server error'}`, 'top');
                } else {
                    notify.error('Failed to get client count. Please check your connection.', 'top');
                }
                totalActiveClients.value = 'Error';
            }
        };

        /**
         * Validate date inputs to ensure they're in correct format and logical
         */
        const validateDates = () => {
            // Helper function to check if date string is complete and valid
            const isDateComplete = (dateString, format) => {
                if (!dateString || dateString.trim() === '') return true; // Empty is valid (optional)
                
                // Check if the date string matches expected length based on format
                const expectedLength = format.length;
                if (dateString.length < expectedLength) return false;
                
                // Parse with strict mode and check validity
                const parsed = dayjs(dateString, format, true);
                return parsed.isValid();
            };

            // Check if all date inputs are complete (if they have values)
            if (!isDateComplete(entryDateFrom.value, dateFormat)) return false;
            if (!isDateComplete(entryDateTo.value, dateFormat)) return false;
            if (!isDateComplete(exitDateFrom.value, dateFormat)) return false;
            if (!isDateComplete(exitDateTo.value, dateFormat)) return false;

            // Only proceed with range validation if dates are complete and valid
            const fromDate = dayjs(entryDateFrom.value, dateFormat, true);
            const toDate = dayjs(entryDateTo.value, dateFormat, true);
            const exitFromDate = dayjs(exitDateFrom.value, dateFormat, true);
            const exitToDate = dayjs(exitDateTo.value, dateFormat, true);

            // Check if entry date range is valid
            if (entryDateFrom.value && entryDateTo.value && fromDate.isValid() && toDate.isValid()) {
                if (fromDate.isAfter(toDate)) {
                    notify.warning('Entry "From" date cannot be after "To" date', 'top');
                    return false;
                }
            }

            // Check if exit date range is valid
            if (exitDateFrom.value && exitDateTo.value && exitFromDate.isValid() && exitToDate.isValid()) {
                if (exitFromDate.isAfter(exitToDate)) {
                    notify.warning('Exit "From" date cannot be after "To" date', 'top');
                    return false;
                }
            }

            return true;
        };    
        
        /**
         * Watch for changes in dataset, database type, service type, date filters, demographic filters, and ASA-specific filters
         */
        watch([dataset, databaseType, serviceType, selectedGender, selectedAgeRange, selectedIwi, selectedEthnicity, asaSelectedSchool, entryDateFrom, entryDateTo, exitDateFrom, exitDateTo, selectedWellbeing], () => {
            // Validate dates before updating map layers
            if (!validateDates()) {
                return;
            }
            
            debouncedUpdateMapLayers(firstLoad.value);
            firstLoad.value = false;
        });

        /**
         * Watch for changes in activeClientsOnly
         */
        watch(activeClientsOnly, () => {
            if (dataset.value === 'Purapura Whetu') {
                debouncedUpdateMapLayers(firstLoad.value);
                firstLoad.value = false;
            }
        });        
        /**
         * Clear all demographic filters when switching datasets
         */
        const clearDemographicFilters = () => {
            selectedGender.value = null;
            selectedAgeRange.value = null;
            selectedIwi.value = null;
            selectedEthnicity.value = null;
        };

        /**
         * Watch for dataset changes to reload appropriate filter options
         */
        watch(dataset, async (newDataset, oldDataset) => {            
            if (newDataset !== oldDataset) {
                // Clear all demographic filters when switching datasets for better UX
                clearDemographicFilters();
                
                // Reload filter options for the new dataset
                await Promise.all([loadAgeRangeOptions(), loadIwiOptions(), loadEthnicityOptions()]);
            }
        });
        onMounted(async () => {
            try {
                // Initialize all data and filters
                await Promise.all([
                    getClientCount(),
                    databaseFilters(),
                    loadDemographicFilters(),
                    loadWellbeingOptions(),
                ]);                
                // Load ASA-specific options if user has access
                if (hasFeature('asaIntegration')) {
                    datasetOptions.value.push({
                        label: 'All ASA Clients',
                        field: 'ASA'
                    });
                    
                    const schoolResponse = await api.asa.getASASchoolList();
                    asaSchoolOptions.value = schoolResponse.data;
                }

                // Generate the map
                map.value = mapSetup.setupMap("map", "mapbox://styles/marshmallowmapbox/cl3tjoru8000614mga48ff757", [172.64, -43.507], 10.15);

                // Populate everything on first load
                map.value.on('load', async () => {
                    await updateMapLayers(firstLoad.value);
                    firstLoad.value = false;
                    loadingFinish.value = true;
                });

                map.value.on('mouseenter', 'data-clientAddress', () => {
                    map.value.getCanvas().style.cursor = 'pointer';
                });
                
                map.value.on('mouseleave', 'data-clientAddress', () => {
                    map.value.getCanvas().style.cursor = '';
                })
            } catch (error) {
                notify.error('Error creating map', 'top');
                loadingFinish.value = true;
            }
        });
          return { 
            dataset,
            datasetOptions,
            userEmail,
            hasFeature,
            loadingFinish,
            loadingMessage,
            loadingDemographicFilters,
            map,
            changeLayers,
            totalActiveClients,
            legendLayer,
            serviceType,
            serviceTypeOptions,
            asaEthnicityOptions,
            asaSchoolOptions,
            asaSelectedEthnicity,
            asaSelectedSchool,
            databaseTypeOptions,
            databaseType,            
            activeClientsOnly,
            isOpen,
            selectedOverlay,
            addressLegendData,
            ethnicityLegendData,
            toggleSidebar,
            dateFormat,
            entryDateFrom,
            entryDateTo,
            exitDateFrom,
            exitDateTo,
            dayjs,            
            genderOptions,
            ageRangeOptions,
            iwiOptions,
            ethnicityOptions,
            selectedGender,
            selectedAgeRange,
            selectedIwi,
            selectedEthnicity,
            wellbeingOptions,
            selectedWellbeing
        };
    }
};
</script>

<style>
@import '../../assets/styles/map.css';
</style>
